import Logger from '@medflex/utils/Logger';
import { jws } from 'jsrsasign';

const parseJwt = token => {
  try {
    return jws.JWS.parse(token).payloadObj;
  } catch (e) {
    Logger.warn(`[parseJsonWebToken] - Failed parsing token ${e.message}`);
    return null;
  }
};

export default parseJwt;
